import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card} from 'react-bootstrap';
import { LAYOUT } from 'constants.js';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import Clamp from 'components/clamp';
import _ from 'lodash';
import PropTypes from 'prop-types';

import WorkexCard from './workexCard';

const Workex = ({user, ...props}) => {
  
  const {workex:exp} = user;

  return (
    <div>
      {!((exp && !_.isEmpty(exp))) && <Row className="g-0">
        <Col>
          <Card className="h-100">
            <Card.Body className="d-flex flex-column justify-content-start">
              <div class="text-muted">No workex or internships added.</div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      }
      {(exp && !_.isEmpty(exp)) && <Row className="row-cols-1 row-cols-md-1 row-cols-xxl-1 g-3">
        <Col>
          {exp.map((item) => <WorkexCard key={item.id} user={user} workex={item} /> )}
        </Col>
      </Row>
      }
    </div>
    
  );
};

export default Workex;
Workex.propTypes = {
  user: PropTypes.object.isRequired,
  workex: PropTypes.object.isRequired
}